module.exports = __webpack_public_path__ + "img/novologolaranja.4475c28e.svg";